import React, { useState } from "react";
import PropTypes from "prop-types";
import { WithContext as ReactTags } from "react-tag-input";
import { TagsInput } from "react-tag-input-component";
import Select from "react-select";

const SelectedAttributeValues = (props) => {
  const {
    attributeOptions,
    delimiters,
    handleAttributeOptionDelete,
    handleAttributeOptionAddition,
    handleAttributeOptionDrag,
    handleAttributeOptionClick,
    selectedAttribute,
    currentIndex,
    labelValue,
    colorssdsd,
  } = props;
  const { value, label } = selectedAttribute || {};
  const [selectedColors, setSelectedColors] = useState();
  const selectedLabel = "Color";
  let attributeIndex = currentIndex;

  console.log(selectedColors, "yaa he attribute thaa sir");

  return (
    <div className="col-md-12 mt-2 mb-2">
      <div className="row movement-of-react-tags">
        <div className="col-md-4">
          <div className="all-color-size-head">
            <div className="color-heading">
              <h5>{label}</h5>
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="all-color-size-input">
            {labelValue.toLowerCase() === selectedLabel.toLowerCase() ? (
              <>
                <Select
                  isMulti={true}
                  options={colorssdsd}
                  class="form-select mt-2 mb-2"
                  classNamePrefix="select Inventory Type"
                  value={selectedColors}
                  // value={attributeOptions[currentIndex]}
                  onChange={(option, currentIndex) => {
                    console.log(option, "dsklaodsak");
                    setSelectedColors(option);
                    props?.setMySelectedColors((preVal)=>[
                      ...preVal,
                      {...option[0]}
                    ])
                    props?.setAllCode((preVal) => [
                      ...preVal,
                      option[0]?.value,
                    ]);
                    // option = {id:option?.[0]?.label,text:option?.[0]?.label}
                    // setSelectedColors(
                    //   handleAttributeOptionAddition({
                    //     attributeOption: option || {},
                    //     attributeIndex: 0 || 0,
                    //     attributeType: label || "",
                    //   })
                    // );
                    setSelectedColors((preVal) => [
                      ...preVal,
                      option[0]?.value,
                    ]);
                    handleAttributeOptionAddition({
                      attributeOption: {
                        id: option.length > 0 ? option[0]?.label : "",
                        text: option.length > 0 ? option[0]?.label : "",
                      },
                      attributeIndex: props?.currentIndex || 0,
                      attributeType: label || "",
                    });
                  }}
                />
              </>
            ) : (
              <>
                {/* <ReactTags
                  tags={attributeOptions[currentIndex]}
                  delimiters={delimiters}
                  handleDelete={(option) =>
                    handleAttributeOptionDelete({
                      attributeOption: option || {},
                      attributeIndex: currentIndex || 0,
                      attributeType: label || "",
                    })
                  }
                  handleAddition={(option) =>
                    handleAttributeOptionAddition({
                      attributeOption: option || {},
                      attributeIndex: currentIndex || 0,
                      attributeType: label || "",
                    })
                  }
                  handleDrag={handleAttributeOptionDrag}
                  handleTagClick={handleAttributeOptionClick}
                  autofocus={false}
                  // inputFieldPosition="bottom"
                  autocomplete ={false}
                  editable = {false}
                /> */}
                <ReactTags
                  tags={attributeOptions[currentIndex]}
                  delimiters={delimiters}
                  handleDelete={(option) =>
                    handleAttributeOptionDelete({
                      attributeOption: option || {},
                      attributeIndex: currentIndex || 0,
                      attributeType: label || "",
                    })
                  }
                  handleAddition={(option) =>{
                    console.log("handleAddition",option);
                    handleAttributeOptionAddition({
                      attributeOption: option || {},
                      attributeIndex: currentIndex || 0,
                      attributeType: label || "",
                    })
                  }}
                  handleDrag={handleAttributeOptionDrag}
                  handleTagClick={handleAttributeOptionClick}
                  autofocus={false}
                  inputFieldPosition="bottom"
                  autocomplete
                  editable
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

SelectedAttributeValues.propTypes = {
  attributeOptions: PropTypes.array.isRequired,
  delimiters: PropTypes.array.isRequired,
  handleAttributeOptionDelete: PropTypes.func.isRequired,
  handleAttributeOptionAddition: PropTypes.func.isRequired,
  handleAttributeOptionDrag: PropTypes.func.isRequired,
  handleAttributeOptionClick: PropTypes.func.isRequired,
  selectedAttribute: PropTypes.object,
  index: PropTypes.number.isRequired,
};

export default SelectedAttributeValues;
